import React from 'react';

const FormWrapper: React.FC = ({ children }) => {
  return <div className="p-10 md:py-12 md:px-20 rounded-md border-l border-gray-500">{children}</div>;
};

export { FormWrapper };
